/**
 * Singapura AR Active Declaration — 폼값 → 템플릿 [[변수]] 변환.
 *   반복부 없음. 조건값(transfers_status/fs_audited/is_*_exempt …)은 백엔드 [[if]] 가 그대로 소비하고,
 *   날짜는 "30 June 2026"(고객 원본 표기)으로 바꿔 넘긴다 — 세션 형식(dd/MM/yyyy)을 따르지 않음(utils/longDate).
 */
import { longDateDeep } from './longDate';

export function normalizeSingapuraActiveDeclarationForWord(input: Record<string, any>): Record<string, any> {
  return longDateDeep({ ...input });
}
